export const TYPE_AVION = 1;
export const TYPE_TRAIN = 2;
